export class PageValidationError extends Error {
  constructor(messages) {
    super()
    this.name = this.constructor.name
    this.messages = messages
  }
}
